import {Component, OnInit} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {TestArea} from 'src/app/common/test-area';
import {ApiService} from 'src/app/services/api.service';
import {ErrorHelper} from '../../common/ErrorHelper';

@Component({
  selector: 'app-refresh-caches',
  templateUrl: './refresh-caches.component.html',
  styleUrls: ['./refresh-caches.component.css']
})
export class RefreshCachesComponent implements OnInit {

  testArea = TestArea;

  constructor(private apiService: ApiService,
              private notifierService: NotifierService) {
  }

  ngOnInit(): void {
  }

  refreshCaches(test: TestArea): void {
    this.apiService.refreshCaches(test).subscribe((success) => {
        console.log('Refreshing caches for ' + test);
      },
      (error) => {
        const errorMessage = ErrorHelper.disectError('refreshCaches for ' + test + ':', error);
        this.notifierService.notify('error', errorMessage);
      },
      () => {
        this.notifierService.notify('success', 'Cache refreshed for ' + test);
      });
  }

}
